var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModifyProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 1C4.69 1 3.625 2.065 3.625 3.375C3.625 4.66 4.63 5.7 5.94 5.745C5.98 5.74 6.02 5.74 6.05 5.745C6.06 5.745 6.065 5.745 6.075 5.745C6.08 5.745 6.08 5.745 6.085 5.745C7.365 5.7 8.37 4.66 8.375 3.375C8.375 2.065 7.31 1 6 1Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1C4.69 1 3.625 2.065 3.625 3.375C3.625 4.66 4.63 5.7 5.94 5.745C5.98 5.74 6.02 5.74 6.05 5.745C6.06 5.745 6.065 5.745 6.075 5.745C6.08 5.745 6.08 5.745 6.085 5.745C7.365 5.7 8.37 4.66 8.375 3.375C8.375 2.065 7.31 1 6 1Z",
    fill: "black",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.54 7.075C7.145 6.145 4.87 6.145 3.465 7.075C2.83 7.5 2.48 8.075 2.48 8.69C2.48 9.305 2.83 9.875 3.46 10.295C4.16 10.765 5.08 11 6 11C6.92 11 7.84 10.765 8.54 10.295C9.17 9.87 9.52 9.3 9.52 8.68C9.515 8.065 9.17 7.495 8.54 7.075Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54 7.075C7.145 6.145 4.87 6.145 3.465 7.075C2.83 7.5 2.48 8.075 2.48 8.69C2.48 9.305 2.83 9.875 3.46 10.295C4.16 10.765 5.08 11 6 11C6.92 11 7.84 10.765 8.54 10.295C9.17 9.87 9.52 9.3 9.52 8.68C9.515 8.065 9.17 7.495 8.54 7.075Z",
    fill: "black",
    fillOpacity: 0.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifyProfile);
export default __webpack_public_path__ + "static/media/modify-profile.acf9266cd75d43854458a9ee6e291a7c.svg";
export { ForwardRef as ReactComponent };